import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ThreeDots } from '../Icons/Icons';
import tailwindTheme from '../../../../../config/tailwind.config';

// items is an array of objects with the name and onClick functions

const EllipseMenuButton = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);
  // Handles the opening and closing menu button
  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };
  const handleClickOut = () => {
    setIsOpen(false);
  };

  const activeButton = isOpen ? 'bg-vamos-green1 text-color-vamos-white' : 'focus:outline-none';
  return (
    <div className="left-0 flex flex-wrap">
      <div className="relative inline-flex">
        <button type="button" onClick={handleClick} className={` w-8 h-8 rounded-full border-0 ${activeButton} focus:outline-none`}>
          <ThreeDots
            color={isOpen ? tailwindTheme.theme.extend.colors['vamos-white'] : tailwindTheme.theme.extend.colors['vamos-black']}
            className="flex items-center justify-center"
          />
        </button>
        {isOpen && (
          <>
            {/* the button is the layer that close the drop down menu when we clicked out the dropdown element  */}
            <button type="button" className="fixed inset-0" onClick={handleClickOut} onKeyDown={handleClickOut} />
            <ul className="w-20 bg-white shadow-vamos-drop-shadow absolute right-0 mt-10 rounded-md z-10">
              {items && items.map((item) => (
                <li key={item.label}>
                  <button
                    type="button"
                    className="block w-full py-2.5 px-3 text-sm text-left bg-vamos-true-white rounded-10px"
                    onClick={(e) => {
                      item.onClick(e);
                      setIsOpen(false);
                    }}
                  >{item.label}
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>

  );
};

EllipseMenuButton.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })).isRequired,
};

export default EllipseMenuButton;
